<template>
    <TransitionRoot as="template" :show="show">
        <Dialog as="div" class="fixed inset-0 overflow-hidden" @close="close()">
            <div class="absolute inset-0 overflow-hidden">
                <DialogOverlay class="absolute inset-0 bg-gray-500 opacity-75"/>
                <div class="fixed inset-y-0 pl-16 max-w-full right-0 flex">
                    <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
                                     enter-from="translate-x-full" enter-to="translate-x-0"
                                     leave="transform transition ease-in-out duration-500 sm:duration-700"
                                     leave-from="translate-x-0" leave-to="translate-x-full">
                        <div class="w-screen max-w-3xl">
                            <form class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
                                  @submit.prevent="submit">
                                <div class="flex-1 h-0 overflow-y-auto">
                                    <div class="py-6 px-4  bg-gradient-to-b from-pitch-purple to-dark-pitch-purple sm:px-6">
                                        <div class="flex items-center justify-between">
                                            <DialogTitle class="text-lg text-white">
                                                Add Supporting Documentation
                                            </DialogTitle>
                                            <div class="ml-3 h-7 flex items-center">
                                                <button type="button"
                                                        class="bg-dark-pitch-purple rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                                                        @click="close()">
                                                    <span class="sr-only">Close panel</span>
                                                    <XIcon class="h-6 w-6" aria-hidden="true"/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="py-6 px-4 sm:px-6">
                                        <div class="flex gap-4">
                                            <div class="flex-grow">
                                                <label for="payment_instructions" class="block text-sm text-gray-900">
                                                    Supporting Documentation
                                                </label>
                                                <label class="w-full mb-4 mt-1 flex flex-col items-center px-4 py-6 bg-white text-blue rounded-lg tracking-wide uppercase border border-blue cursor-pointer">
                                                    <svg class="w-8 h-8" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                                                    </svg>
                                                    <!-- <span class="mt-2 text-base leading-normal">Select a file</span> -->
                                                    <span v-if="form.file_uploads.length === 0" class="mt-2 text-base leading-normal">Select a file</span>
                                                    <span v-else>{{ form.file_uploads.length }} file<span v-if="form.file_uploads.length > 1">s</span> selected for upload</span>
                                                    <input type='file' class="hidden" multiple @change="prepareFileUpload($event)" name="file_upload" />
                                                </label>
                                            </div>
                                        </div>
                                        <div class="flex-shrink-0 flex justify-end">
                                            <button v-if="form.file_uploads.length === 0" disabled
                                                    type="submit"
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200 w-full">
                                                <span>Upload</span>
                                            </button>
                                            <button v-else
                                                    type="submit"
                                                    class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm rounded-md text-white bg-pitch-purple hover:bg-dark-pitch-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-200 w-full">
                                                <span>Upload</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
<script>
import {ref, reactive, computed} from 'vue'
import {Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import {XIcon} from '@heroicons/vue/outline'
import {useForm, usePage} from '@inertiajs/vue3'
import SlideOutErrors from "@/Components/SlideOutErrors";

export default {
    components: {
        SlideOutErrors,
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
        XIcon,
    },
    props: {
        fixture: Object,
        invoice_type: String,
    },
    data() {
        return {
            show: ref(false),
            fixture: computed(() => usePage().props.fixture),
            quote: computed(() => usePage().props.quote),
            invoice: null,
            invoice_type: null,
            form: useForm({
                supporting_documentation: [],
                file_uploads: []
            })
        }
    },
    methods: {
        open(invoice, invoice_type) {
            this.show = true;
            this.invoice = invoice;
            this.invoice_type = invoice_type;
        },
        close() {
            this.show = false;
        },
        submit() {
            // Instantiate blank url variable
            var url = '';
            
            // Build the url depending on the invoice type
            switch(this.invoice_type) {
                case 'Management Fee':
                    url = route('frontend.management-fees.add-supporting-documents', [this.invoice.id]);
                    break;
                case 'Invoice':
                    url = route('frontend.fixture.invoice.add-spporting-documents', [this.fixture.id, this.invoice.id])
                    break
                case 'Commission':
                    url = route('frontend.fixture.invoice.add-spporting-documents', [this.fixture.id, this.invoice.id])
                    break
            }

            // Submit the form
            this.form.post(url), {
                onSuccess: page => {
                    this.show = false;
                    this.form.reset();
                }
            };
        },
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        },
        prepareSupportingDocumentationUpload(event) {
            this.form.supporting_documentation = event.target.files
        },
        prepareFileUpload(event) {
            this.form.file_uploads = event.target.files
        },
        prepareSupportingDocumentationUpload(event) {
            this.form.supporting_documentation = event.target.files
        }
    }
}
</script>
